import { render, staticRenderFns } from "./HomeEdit.vue?vue&type=template&id=60a3ddbc&"
import script from "./HomeEdit.vue?vue&type=script&lang=ts&"
export * from "./HomeEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports